var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { attrs: { id: "footer" } }, [
    _c("div", { staticClass: "inner" }, [
      _c("div", { staticClass: "left-container" }, [
        _c(
          "button",
          {
            staticClass: "f-menu",
            attrs: { type: "button" },
            on: { click: _vm.getPolicyModal }
          },
          [_vm._v(_vm._s(_vm.$t("sdl.privacyPolicy.policy")))]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "f-copy" }, [
          _vm._v("Copyright 2024 SAMSUNG. All rights reserved.")
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-container" }, [
      _c("span", { staticClass: "f-logo" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf7711a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf7711a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/GcrmFooter.vue
// module id = null
// module chunks = 